export default "__VITE_ASSET__CIPsqhvr__";